
export default {
    methods: {
        setFeedback(timeout, title) {
            //use router meta tags in case method is not passed in with title.
            let feedbackTitle = title ? title : this.$route.meta.feedbackTitle

            setTimeout(() => {
                this.$ehFeedbackInstance.showFeedbackModal(feedbackTitle)
            },timeout)
        }
    }
}